<template>
  <div>

    <div class="v-data-table-footer">

      <div class="v-data-table-footer__items-per-page">

        <span>Items per page:</span>

        <v-select
          :value="itemsPerPage"
          @update:modelValue="$emit('update:itemsPerPage', $event)"
          :items="itemsPerPageOptions"
          density="compact"
          variant="outlined"
          hide-details
        />

      </div>

      <div class="v-data-table-footer__info">
        <div>{{ (page - 1) * itemsPerPage + 1 }}&ndash;{{ Math.min(items.length, page * itemsPerPage) }} of {{ items.length }}</div>
      </div>

      <div class="v-data-table-footer__pagination">

        <!--
        <v-pagination
          :length="numPages"
          :value="page"
          @update:modelValue="$emit('update:page', $event)"
        />
        -->

        <v-btn
          variant="plain"
          color="pagination-button-foreground"
          icon="$first"
          :disabled="page <= 1"
          aria-label="First page"
          @click="$emit('update:page', 1)"          
        />

        <v-btn
          variant="plain"
          color="pagination-button-foreground"
          icon="$prev"
          :disabled="page <= 1"
          aria-label="Previous page"
          @click="$emit('update:page', page - 1)"
        />

        <v-btn
          variant="plain"
          color="pagination-button-foreground"
          icon="$next"
          :disabled="page >= numPages"
          aria-label="Next page"
          @click="$emit('update:page', page + 1)"
        />

        <v-btn
          variant="plain"
          color="pagination-button-foreground"
          icon="$last"
          :disabled="page >= numPages"
          aria-label="Last page"
          @click="$emit('update:page', numPages)"
        />

      </div>

    </div>

  </div>
</template>

<script setup lang="ts">

/**
 * Vuetify's VDataTable component doesn't provide a way to reset the page
 * number to 1 (e.g., when the, because a filter was changed). This component
 * was created as a workaround.
 */

import { computed } from 'vue'

interface Props {
  items: any[] // TODO
  page: number
  itemsPerPage?: number
}

const props = withDefaults(defineProps<Props>(), {
  itemsPerPage: 10,
})

const numPages = computed<number>(() => {
  return Math.ceil(props.items.length / props.itemsPerPage)
})

defineEmits(['update:page', 'update:itemsPerPage'])

const itemsPerPageOptions = [
  { value: 10, title: '10' },
  { value: 25, title: '25' },
  { value: 50, title: '50' },
  { value: 100, title: '100' },
  { value: -1, title: 'All' },
]

</script>
